import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/landingpage-phone.png'
import _imports_1 from '@/assets/appstoreBadge.svg'
import _imports_2 from '@/assets/googleplayBadge.svg'
import _imports_3 from '@/assets/featurespage-phoneLaptop.png'


const _withScopeId = n => (_pushScopeId("data-v-59b7fee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  class: "headerWrapper"
}
const _hoisted_4 = { class: "text-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, " Send files, images, and text in an instant between your devices with Shipd ")
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"plattforms\" data-v-59b7fee2><a class=\"ghostLink\" target=\"_blank\" href=\"https://apps.apple.com/se/app/shipd-mobile/id6443850361?l=en\" data-v-59b7fee2><img class=\"plattform\" src=\"" + _imports_1 + "\" alt=\"apple\" data-v-59b7fee2></a><a class=\"ghostLink\" target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=co.getshipd.mobile\" data-v-59b7fee2><img class=\"plattform\" src=\"" + _imports_2 + "\" alt=\"android\" data-v-59b7fee2></a></div>", 1)
const _hoisted_8 = {
  key: 0,
  src: _imports_3,
  alt: "Laptop",
  class: "image"
}
const _hoisted_9 = {
  key: 2,
  class: "text-wrapper"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " Send files, images, and text in an instant between your devices with Shipd ", -1))
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"plattforms\" data-v-59b7fee2><a class=\"ghostLink\" target=\"_blank\" href=\"https://apps.apple.com/se/app/shipd-mobile/id6443850361?l=en\" data-v-59b7fee2><img class=\"plattform\" src=\"" + _imports_1 + "\" alt=\"apple\" data-v-59b7fee2></a><a class=\"ghostLink\" target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=co.getshipd.mobile\" data-v-59b7fee2><img class=\"plattform\" src=\"" + _imports_2 + "\" alt=\"android\" data-v-59b7fee2></a></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.windowSize < 995)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    ($setup.windowSize >= 995)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (!$setup.isMobile)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Download Shipd for desktop"))
              : _createCommentVNode("", true),
            (!$setup.isMobile)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "register",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.download && $setup.download(...args)))
                }, " Download for " + _toDisplayString($setup.OSName), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString($setup.isMobile ? "G" : "And g") + "et the mobile app to get started!", 1),
            _hoisted_7
          ]),
          ($setup.windowSize >= 995)
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString($setup.isMobile ? "G" : "And g") + "et the mobile app for your device to get started! ", 1),
          _hoisted_11
        ]))
  ]))
}